<table>
  <thead>
    <th *ngFor="let day of month[0]" class="ds-font-display ds-text-lg">
      <span>{{ day | date: "EEEEE" }}</span>
    </th>
  </thead>
  <tbody>
    <tr *ngFor="let week of month">
      <ui-day
        *ngFor="let day of week"
        [day]="day"
        [selected]="selected"
        [min]="min"
        [max]="max"
        [isHidden]="isHidden(day)"
        [isDisabled]="isDisabled(day)"
        [isSelected]="isSelected(day)"
        (selectedDayChange)="onSelectedChange($event)"
      ></ui-day>
    </tr>
  </tbody>
</table>
